module.exports = __webpack_public_path__ + "img/bjx_10.6ef96971.png";